import styled from 'styled-components';
import tinycolor from 'tinycolor2';

export const Empty = styled.form<{ _textColor: string }>`
  font-size: 15px;
  text-align: left;
  color: ${({ _textColor }) =>
    tinycolor(String(_textColor)).setAlpha(0.7).toString()};
`;
